export const submissionabstractLink =
  "https://easychair.org/conferences/?conf=5thiceba2024";
export const submissionfullLink =
  "https://easychair.org/conferences/?conf=5thiceba2024";
export const registerLink = "https://forms.gle/FAVQRub9wZYcLiMZ6";
